export default __webpack_public_path__ + "static/media/eba_thumbnail.7844ca5c.jpeg";